<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part" id="part02"><a id="page_23"></a>PART 2: UFOS, ALIENS, AND COSMIC CONSPIRACIES</h2>
<p class="noindent"><a id="page_24"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part02.vue?38810d1a